import { forwardRef } from 'react';
import type { ChangeEvent, InputHTMLAttributes } from 'react';
import { Input } from './Input';
import { isValidPhoneNumber } from '../../lib/utils';

interface PhoneInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string | { message?: string } | null;
  helper?: string;
}
export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  (
    {
      label = 'Phone Number',
      placeholder = '0241234567',
      maxLength = 15,
      onChange,
      ...rest
    },
    ref,
  ) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      e.target.value = e.target.value.replace(/[^\d+]/g, '');
      onChange?.(e);
    };

    return (
      <Input
        ref={ref}
        label={label}
        type="tel"
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={handleChange}
        {...rest}
      />
    );
  },
);

PhoneInput.displayName = 'PhoneInput';

export function phoneFieldRules(options?: { required?: boolean; message?: string }) {
  const required = options?.required ?? true;
  const message = options?.message ?? 'Phone number is required';
  return {
    ...(required ? { required: message } : {}),
    validate: (v: string) =>
      !v || isValidPhoneNumber(v) || 'Enter a valid phone number (e.g. 0241234567)',
  };
}
